<template>
<svg class="cnm-icon" width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M16.7817 15.8104H18.4567C19.5613 15.8104 20.4567 14.915 20.4567 13.8105V5.8667C20.4567 4.76213 19.5613 3.8667 18.4567 3.8667H10.5129C9.40837 3.8667 8.51294 4.76213 8.51294 5.8667V7.5417" stroke="black" stroke-width="1.5"/>
<rect x="3" y="9.37915" width="11.9438" height="11.9438" rx="2" fill="black" stroke="black" stroke-width="1.5"/>
</svg>
</template>